import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useColors } from '../../../hooks/useColors';
import { useTextReplacement } from '../../../hooks/useTextReplacement';

/**
 * Component to display when user has insufficient credits
 * @param {Object} props - Component props
 * @param {string} props.message - Custom message to display
 * @param {Function} props.onDismiss - Function to call when dismissing the message
 * @param {string} props.purchaseUrl - URL for purchasing credits
 */
const InsufficientCreditsMessage = ({ 
  message,
  onDismiss,
  purchaseUrl = '/home/order'
}) => {
  const { semantic } = useColors();
  const { replace } = useTextReplacement();
  
  const defaultMessage = replace('You don\'t have enough credits to perform this action.');
  const displayMessage = message || defaultMessage;
  
  return (
    <div className={`${semantic.errorBg} ${semantic.errorBorder} ${semantic.errorText} border px-4 py-3 rounded relative mb-4`} role="alert" aria-live="assertive">
      <div className="flex items-start">
        <div className="py-1">
          <svg 
            className={`fill-current h-6 w-6 ${semantic.errorText} mr-4`} 
            xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 20 20"
            aria-hidden="true"
          >
            <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"/>
          </svg>
        </div>
        <div>
          <p className="font-bold">{replace('Insufficient Credits')}</p>
          <p className="text-sm">{replace(displayMessage)}</p>
          <div className="mt-3">
            <Link 
              to={purchaseUrl}
              className={`inline-block ${semantic.actionButtonPurchase} font-bold py-2 px-4 rounded mr-2`}
            >
              {replace('Purchase Credits')}
            </Link>
            {onDismiss && (
              <button 
                onClick={onDismiss}
                className={`inline-block bg-transparent hover:${semantic.errorBg} ${semantic.errorText} font-semibold py-2 px-4 border ${semantic.errorBorder} hover:border-transparent rounded`}
                aria-label={replace('Dismiss message')}
              >
                {replace('Dismiss')}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

InsufficientCreditsMessage.propTypes = {
  message: PropTypes.string,
  onDismiss: PropTypes.func,
  purchaseUrl: PropTypes.string
};

export default InsufficientCreditsMessage;

